import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function NowMarker() {
  const { t, i18n } = useTranslation(['common']);
  const locale = i18n.language === 'de' ? 'de-DE' : 'en-US';
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="flex items-center gap-3 my-3" aria-label={t('mobile.now')}>
      <div className="flex-1 h-px bg-[var(--pb-primary)]" />
      <div className="text-xs font-semibold text-[var(--pb-primary)] uppercase tracking-wide">
        {t('mobile.now')} {now.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })}
      </div>
      <div className="flex-1 h-px bg-[var(--pb-primary)]" />
    </div>
  );
}
